import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import HomeworkResult from '../../template/HomeworkNew/HomeworkResult';
import StepChange from '../../template/HomeworkNew/StepChange';
import { parseQuery } from '../../utils/tools';
import AXIOS from '../../api/axios';
// import clientApi from '../../api/client';
// import Toast from '../../utils/toast';

const queryObj = parseQuery(window.location.search.slice(1));

class HomeworkResultPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showStepChange: true
        };
        this.timeOutArr = [];
    }
    componentDidMount() {
        AXIOS.homeworkEnd({
            data:{
                classSchId: queryObj.classschid,
                type: 0
            }
        },(res, err)=>{
            if(err) console.log(err.errorMessage)
            else{
                this.setState({
                    awardCnt: res.awardCnt,
                    starnum: res.score,
                    completeRender: true
                },()=>{
                    this.stepChangeRef.cloudPlay(()=>{
                        this.timeOutArr.push(
                            setTimeout(() => {
                                this.setState({
                                    showStepChange: false,
                                    stepChange: 'out'
                                })
                            }, 1200)
                        );
                    })
                })
            }
        })
    }
    render() {
        const { stepChange, showStepChange, starnum, awardCnt, completeRender } = this.state;
        return (
            <DocumentTitle title={'课后作业'}>
                <React.Fragment>
                    {completeRender &&
                        <HomeworkResult starnum={starnum} awardCnt={awardCnt} />
                    }
                    {showStepChange && (
                        <StepChange status={stepChange || 'in'} ref={com => this.stepChangeRef = com} />
                    )}
                </React.Fragment>
            </DocumentTitle>
        );
    }
}

export default HomeworkResultPage;



// WEBPACK FOOTER //
// ./src/components/homeworkNewPage/HomeworkResultPage.jsx